import { render, staticRenderFns } from "./ContactNotes.vue?vue&type=template&id=786506a0&scoped=true&"
import script from "./ContactNotes.vue?vue&type=script&lang=js&"
export * from "./ContactNotes.vue?vue&type=script&lang=js&"
import style0 from "./ContactNotes.vue?vue&type=style&index=0&id=786506a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786506a0",
  null
  
)

export default component.exports